import {
  Component,
  EventEmitter,
  Injector,
  Input,
  OnInit,
  Output
} from "@angular/core";
import { GenericComponent } from "../../components/generic.component";
import { UntypedFormControl, Validators } from "@angular/forms";
import { MatOptionSelectionChange } from "@angular/material/core";
import { HelperService } from "src/app/core/services/helper.service";
import { MeasurementUnitDTO } from "../../models/measurement-unit-dto";
import { PartService } from "src/app/core/services/part.service";

@Component({
    selector: "app-smartfleet-measurement-unit-auto-complete",
    templateUrl: "./measurement-unit-auto-complete.component.html",
    styleUrls: ["./measurement-unit-auto-complete.component.scss"],
    standalone: false
})
export class MeasurementUnitAutoCompleteComponent
  extends GenericComponent
  implements OnInit
{
  _disabled = false;
  name = new UntypedFormControl();
  searchForm = this.fb.group({
    name: this.name
  });

  allMeasurementUnits: MeasurementUnitDTO[] = [];
  measurementUnits: MeasurementUnitDTO[] = [];

  @Input() title = "";
  @Input() requiredText = "";
  @Input() set required(value: boolean) {
    if (value && !this._disabled) {
      this.searchForm.get("name").setValidators([Validators.required]);
    }
  }
  @Input() set disabled(value: boolean) {
    this._disabled = value;
    if (value) {
      this.searchForm.disable();
    } else {
      this.searchForm.enable();
    }
  }

  @Output() onChange: any = new EventEmitter<MeasurementUnitDTO>();

  constructor(
    private partService: PartService,
    private helperService: HelperService,
    injector: Injector
  ) {
    super(injector);
  }

  ngOnInit() {
    this.getMeasurementUnits();

    this.name.valueChanges.subscribe((value) => {
      if (value) {
        this.measurementUnits = this.allMeasurementUnits.filter((item) => {
          const description = `${this.helperService.normalizeWord(
            item.value
          )} - ${this.helperService.normalizeWord(item.description)}`;
          return description.includes(this.helperService.normalizeWord(value));
        });
      } else {
        this.measurementUnits = this.allMeasurementUnits;
        this.onChange.emit({} as MeasurementUnitDTO);
      }
    });
  }

  handleUnitChange(
    event: MatOptionSelectionChange,
    measurementUnit: MeasurementUnitDTO
  ) {
    if (event.isUserInput === true) {
      this.onChange.emit(measurementUnit);
    }
  }

  clean(): void {
    this.searchForm.reset();
    this.measurementUnits = this.allMeasurementUnits;
  }

  setValue(value: string): void {
    this.searchForm.get("name").setValue(value);
  }

  getMeasurementUnits() {
    this.allMeasurementUnits = this.partService.getMeasurementUnits(
      this.translateService.currentLang
    );
    this.measurementUnits = this.allMeasurementUnits;
  }
}
